<span class="btn-flat-primary" *ngIf="loading">
  <div class="spinner-border spinner-border-sm text-primary" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</span>

<ng-container *ngIf="!loading">
  <span class="btn-flat-secondary" *ngIf="status === 'stop' && s">
    <mat-icon fontIcon="play_arrow"></mat-icon>
  </span>
  <span
    class="waves-effect btn-flat-success"
    *ngIf="status === 'stop' && !s"
    (click)="handleChange('start')"
  >
    <mat-icon fontIcon="play_arrow"></mat-icon>
  </span>
  <span
    class="waves-effect btn-flat-danger"
    *ngIf="status === 'start'"
    (click)="handleChange('stop')"
  >
    <mat-icon fontIcon="stop"></mat-icon>
  </span>
</ng-container>
